// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"079a8c8b","642":"575f9209","658":"56d07de0","728":"d99f62ce","810":"5c2ec5f7","982":"f13c286f"}[chunkId] + ".chunk.js";
};